import { Component, OnInit, Signal, computed, signal, HostListener } from '@angular/core';
import { CommonModule, Location, NgClass, NgFor, NgIf } from '@angular/common';
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { PropertyService } from '../../../_services/properties/property.service';
import { InrShortPipe } from '../../../_pipes/indian-currency.pipe';
import { UsersService } from '../../../_services/users.service';
import { ToastService } from '../../../_services/toast.service';
import { PropertySearchPipe } from '../../../_pipes/property-search.pipe';
import { AuthService } from '../../../_services/auth.service';
import { LoaderService } from '../../../_services/loader.service';
import { AdvisorService } from '../../../_services/advisor/advisor.service';

interface Property {
  _id: string;
  name: string;
  builder: string;
  price: any;
  priceUnit: string;
  propertyType: string;
  bedrooms: number;
  landArea: number;
  location: string;
  shortDescription: string;
  isSoldOut: boolean;
  isLiked: boolean;
  galleryImage: any;
  microMarket?: {
    micromarketName?: string;
    cluster?: string;
  };
}

type User = {
  _id: string;
  name: string;
  email: string;
  phone: string;
  otp: string | null;
  password: string;
  otpVerified: boolean;
  role: any;
};

@Component({
  selector: 'app-user-info',
  standalone: true,
  imports: [
    CommonModule,
    NgIf,
    NgFor,
    NgClass,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    InrShortPipe
  ],
  providers: [InrShortPipe],
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
})
export class UserInfoComponent implements OnInit {
  tabs = [
    'User Profile',
    'Requests',
    'Customer Preferences',
    'Curate Property Links',
    'Shared Links'
  ];
  activeTab = 'User Profile';
  allProperties: Property[] = [];
  isAssignAdvisor = signal(false);
  isGenerateLink = signal(false);
  userRequest: any = signal([]);
  userDetails: any = {};
  searchTerm: string = '';
  requestForm!: FormGroup;
  filteredProperties: Property[] = [];
  microMarketDropdownOpen = false;
  projectStatusDropdownOpen = false;
  microMarketSearch = '';
  selectedPropertyIds = new Set<string>();
  filteredMicroMarkets: string[] = [];
  microMarketOptions: string[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalPages: number = 0;
  searchTimeout: any;
  advisorList:any = signal([])
  allAdvisors:any = []

   // Track the single selected advisor
   selectedAdvisorId = signal<string | null>(null);
   selectedPropReq = signal<any>({});
   isConfirmDisabled = computed(() => this.selectedAdvisorId() === null);

  showApprovalModal = false;
  approvalReason:string = '';
  approvalState = '';
  approvalUserId = '';
  isSubmittingApproval = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private readonly propertyService: PropertyService,
    private inrShortPipe: InrShortPipe,
    private route: ActivatedRoute,
    public _US: UsersService,
    private _NS: ToastService,
    private location: Location,
    private _AS: AuthService,
    private loaderService : LoaderService,
    private readonly _AsS : AdvisorService
  ) {}

  

  // microMarketOptions: string[] = [
  //   'Indiranagar',
  //   'Koramangala',
  //   'Whitefield',
  //   'Sarjapur',
  //   'Hebbal',
  //   'Yelahanka',
  //   'Electronic City',
  //   'HSR Layout',
  //   'JP Nagar',
  //   'Jayanagar',
  // ];

  budgetOptions: string[] = [
    '₹0 – ₹5Cr',
    '₹5Cr – ₹10Cr',
    '₹10Cr – ₹15Cr',
    '₹15Cr – ₹25Cr',
    '₹25Cr+',
  ];

  configurationOptions: string[] = [
    '3BHK (2,500Sq ft to 3,000Sq ft)',
    '3BHK + Maids (2,800Sq ft to 3,200Sq ft)',
    '4BHK + Maids (3,000Sq ft to 4,000Sq ft)',
    '5BHK + Maids (4,000Sq ft to 7,000Sq ft)',
    'Pent House - 3/4BHK',
    'Villa’s',
    'Independent plot',
    'Independent plot with a house',
  ];

  communityOptions: string[] = [
    'Boutique apartments (8–10 homes, prime address)',
    'Large community (25+ apartments with amenities)',
    'Other – open to anything',
  ];

  projectStatusOptions: string[] = [
    'Under construction (up to 3 years)',
    'Nearing completion (6–12 months)',
    'Ready to move-in',
    'Resale – Older apartments',
    'Ok with all',
  ];
  filteredCluster:any = []
  ngOnInit(): void {
    this.route.queryParamMap.subscribe(async (params) => {
      const id = params.get('id');
      await this.getAllMicroMarket()
      this.getUserDetails(id);
      this.getUserPropReq(id);
      this.getUserCustomerPre(id)
      this.getAllAdvisor();
      this.getUserSharedProperty(id)
    });
    this.initRequestForm();
    this.loadAllProperties();
    this.filteredMicroMarkets = [...this.microMarketOptions];
  }
  savedCluster:any =[]
  getAllMicroMarket(){
    this._US.getAllMircoMarketReq().subscribe((res:any)=>{
      this.savedCluster = this.filterDuplicateMicromarkets(res)
      this.filteredCluster = this.filterDuplicateMicromarkets([...this.savedCluster]);
    })
  }
  filterDuplicateMicromarkets(data:any) {
    const seen = new Set();
    return data.filter((item:any) => {
      const key = `${item.micromarketName}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }
  getUserDetails(id: any) {
    this._US.getUserDetails(id).subscribe((res: any) => {
      this.userDetails = res;
      console.log('User Details FULL:', this.userDetails);
      console.log('this.userDetails', this.userDetails)
      let advisorId = this.userDetails?.assignedAdvisor?.advisorId || null;
      this.selectAdvisor(advisorId)
    });
  }

  private initRequestForm(): void {
     this.requestForm = this.fb.group({
      microMarkets: [[], [Validators.required, this.maxSelectionValidator(3)]],
      budgetRange: ['', Validators.required],
      configuration: ['', Validators.required],
      communityPreference: ['', Validators.required],
      projectStatus: [[], Validators.required],
      notes: ['', [Validators.maxLength(200)]],
    });
  }
  maxSelectionValidator(max: number) {
    return (control: any) => {
      const value = control.value || [];
      return value.length <= max ? null : { maxSelection: true };
    };
  }
  isInvalid(controlName: string): boolean {
    const control = this.requestForm.get(controlName);
    return !!(control && control.invalid && (control.touched || control.dirty));
  }
  
  

  loadAllProperties() {
    this.propertyService.properties(1, 1000).subscribe((res: any) => {

      if (res?.status) {
        this.allProperties = res.data || [];

        const markets = this.allProperties
          .map((p: any) => p?.microMarket?.micromarketName)
          .filter((m): m is string => !!m)

        this.microMarketOptions = [...new Set(markets)];
        this.filteredMicroMarkets = [...this.microMarketOptions];

        this.currentPage = 1;
        this.applySearchAndPagination();
      }
    });
  }

  applySearchAndPagination() {
    const search = this.searchTerm?.toLowerCase().trim().replace(/\s+/g, ' ');

    let data = [...this.allProperties];

    if (search) {
      data = data.filter((property: any) => {

        const name = property.name?.toLowerCase() || '';
        const location = property.location?.toLowerCase() || '';

        const microMarket =
          property?.microMarket?.micromarketName?.toLowerCase() || '';

        const cluster =
          property?.microMarket?.cluster?.toLowerCase() || '';

        const builder = property.builder?.toLowerCase() || '';
        const type = property.propertyType?.toLowerCase() || '';

        const bhk = this.getBHKAndPriceRange(property.price)?.bhkRange?.toLowerCase() || '';

        const price = this.formatPriceDisplay(property.price)?.toLowerCase() || '';

        const status = property.isSoldOut ? 'sold out' : 'active';

        return (
          name.includes(search) ||
          location.includes(search) ||
          microMarket.includes(search) ||
          cluster.includes(search) ||
          builder.includes(search) ||
          type.includes(search) ||
          bhk.includes(search) ||
          price.includes(search) ||
          status.includes(search)
        );
      });
    }

    // Pagination (unchanged)
    this.totalPages = Math.ceil(data.length / this.itemsPerPage);

    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;

    this.filteredProperties = data.slice(start, end);
  }
  

  canGenerateLink(): boolean {
    const hasRequests = this.userRequest()?.length > 0;
    const hasPreferences = this.requests?.length > 0;

    return hasRequests || hasPreferences;
  }
  showGenerateError() {
    if (!this.hasAdvisorAssigned()) {
      this._NS.error('Please assign an advisor before generating a link');
      return;
    }

    if (!this.canGenerateLink()) {
      this._NS.error(
        "You need at least one request or preference to generate a link"
      );
    }
  }
  

  viewDetails(property: Property): void {
    this.router.navigate(['admin/property/details'], {
      queryParams: {
        id: property._id,
        mode: 'details',
      },
    });
  }

  navigateToGallery(property: Property): void {
    this.router.navigate(['admin/property/image-upload', property._id], {
      queryParams: {
        mode: 'gallery',
      },
    });
  }

  formatPriceDisplay(priceData: any): string {
    if (!priceData) return 'N/A';
    if (Array.isArray(priceData)) {
      if (priceData.length === 0) return 'N/A';
      const values = priceData
        .map((p) => Number(p.price))
        .filter((v) => !isNaN(v));
      if (values.length === 0) return 'N/A';

      const min = Math.min(...values);
      const max = Math.max(...values);
      if (values.length === 1 || min === max) {
        return this.inrShortPipe.transform(min);
      }
      return `${this.inrShortPipe.transform(
        min
      )} - ${this.inrShortPipe.transform(max)}`;
    }
    return this.inrShortPipe.transform(priceData);
  }
  getBHKAndPriceRange(priceArray: any[]) {
    if (!priceArray || priceArray.length === 0) {
      return { bhk: 'N/A', price: 'Price on Request' };
    }
    const bhkValues = priceArray
      .map((p) => parseFloat(p.bhkType))
      .sort((a, b) => a - b);

    const minBhk = bhkValues[0];
    const maxBhk = bhkValues[bhkValues.length - 1];
    const priceValues = priceArray.map((p) => p.price).sort((a, b) => a - b);

    const minPrice = priceValues[0];
    const maxPrice = priceValues[priceValues.length - 1];
    return {
      bhkRange:
        minBhk === maxBhk ? `${minBhk} BHK` : `${minBhk} - ${maxBhk} BHK`,
      priceRange:
        minPrice === maxPrice
          ? this.inrShortPipe.transform(minPrice)
          : `${this.inrShortPipe.transform(
              minPrice
            )} - ${this.inrShortPipe.transform(maxPrice)}`,
    };
  }
  isPropertySelected(id: string): boolean {
    return this.selectedPropertyIds.has(id);
  }
  togglePropertySelection(id: string) {
    if (this.selectedPropertyIds.has(id)) {
      this.selectedPropertyIds.delete(id);
    } else {
      this.selectedPropertyIds.add(id);
    }
  }
  toggleSelectAll(event: any) {
    const isChecked = event.target.checked;
    if (isChecked) {
      this.allProperties.forEach((p) =>
        this.selectedPropertyIds.add(p._id)
      );
    } else {
      this.selectedPropertyIds.clear();
    }
  }
  isAllSelected(): boolean {
    return (
      this.filteredProperties.length > 0 &&
      this.selectedPropertyIds.size === this.filteredProperties.length
    );
  }

  generatedLink: string = '';
  isLoading: boolean = false;
  isCopied: boolean = false;

  get selectedData() {
    return this.allProperties.filter((p) =>
      this.selectedPropertyIds.has(p._id)
    );
  }

  get isSelectionValid(): boolean {
    return (
      this.selectedPropertyIds.size > 0 && this.selectedPropertyIds.size <= 3
    );
  }

  createShareLink() {
    this.isGenerateLink.set(true);
  }

  async generateShareLink() {
    // if (!this.isSelectionValid) return;
    this.isLoading = true;
    const payload = {
      user:this.userDetails,
      propertyIds: [...this.selectedPropertyIds],
    };
    try {
      const response: any = await this.propertyService
        .generatePropertyLinks(payload)
        .toPromise();
      this.generatedLink = response.data[0].publicUrl;
    } catch (err) {
      console.error('Link generation error', err);
    } finally {
      this.isLoading = false;
    }
  }

  copyLink() {
    if (!this.generatedLink) return;
    // Modern clipboard API (HTTPS)
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(this.generatedLink)
        .then(() => {
          this.showCopied();
        })
        .catch(() => {
          this.fallbackCopy();
        });
    } else {
      // Fallback for HTTP
      this.fallbackCopy();
    }
  }

  private fallbackCopy() {
    const textarea = document.createElement('textarea');
    textarea.value = this.generatedLink;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    this.showCopied();
  }

  private showCopied() {
    this.isCopied = true;
    setTimeout(() => (this.isCopied = false), 2000);
  }
  assignAdvisor(request: any): void {
    this.isAssignAdvisor.set(true);
  }
  closeModal(): void {
    this.isAssignAdvisor.set(false);
    this.selectAdvisor(null)
  }
  closeSharePropertyModal(): void {
    this.isGenerateLink.set(false);
    this.selectedPropertyIds.clear();
  }
  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  getUserPropReq(userId: any) {
    this._US.getUserPropertyReq(userId).subscribe({
      next: (res: any) => {
        if (res.status && res.data.length) {
          this.userRequest.set(res.data);
          // this._NS.success(res.message);
        } else {
          this._NS.error(
            res.message || 'Something went wrong. Please try again.'
          );
        }
      },
      error: (err: any) => {
        const errorMsg = err.message || 'Server connection failed';
        this._NS.error(errorMsg);
      },
    });
  }
  trackByRequestId(index: number, item: any): string {
    return item._id; // Unique identifier from your JSON
  }

  isApprovedUser(userId: any, state: string, reason:string) {
    this._US.getUserUpdateState(userId, state,reason).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.userRequest.set(res.data);
          this.refreshUIState(res.data._id);
          this._NS.success(res.message);
        } else {
          this._NS.error(
            res.message || 'Something went wrong. Please try again.'
          );
        }
      },
      error: (err: any) => {
        const errorMsg = err.message || 'Server connection failed';
        this._NS.error(errorMsg);
      },
    });
  }

  refreshUIState(id: any) {
    this.getUserDetails(id);
    this.getUserPropReq(id);
    this.loadAllProperties();
  }
  onSearchChange() {
    clearTimeout(this.searchTimeout);

    this.searchTimeout = setTimeout(() => {
      this.currentPage = 1;
      this.applySearchAndPagination();
    }, 400);
  }
  changePage(page: number) {
    if (page < 1 || page > this.totalPages) return;

    this.currentPage = page;
    this.applySearchAndPagination();
  }
  getVisiblePages(): number[] {
    const pages: number[] = [];
    const start = Math.max(1, this.currentPage - 2);
    const end = Math.min(this.totalPages, this.currentPage + 2);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  }

  isDeleting = false; // New state for premium UX
  userIdToDelete: string | null = null;
  showDeleteModal = false;
  // Open the modal
  openDeleteConfirm(id: string) {
    this.userIdToDelete = id;
    this.showDeleteModal = true;
  }
  deleteUser() {
    if (!this.userIdToDelete) return;
    this.isDeleting = true; // Start loading

    this._US.deleteUser(this.userIdToDelete).subscribe({
      next: (res: any) => {
        this.isDeleting = false;
        if (res.status) {
          this.showDeleteModal = false;
          this._NS.success(res.message);
          setTimeout(() => this.location.back(), 300); // Slight delay for smooth exit
        } else {
          this._NS.error(res.message);
        }
      },
      error: (err: any) => {
        this.isDeleting = false;
        this._NS.error('Server connection failed');
      },
    });
  }
  showRequestModal = false;

  requests: any[] = [];

  openRequestModal() {
    this.showRequestModal = true;
  }

  closeRequestModal() {
    this.showRequestModal = false;
    this.requestForm.reset({
      microMarkets: [],
      projectStatus: []
    });
    this.requestForm.markAsPristine();
    this.requestForm.markAsUntouched();
    this.selectAdvisor('');
  }
  saveRequest(): void {
    if (this.requestForm.invalid) {
      this.requestForm.markAllAsTouched();
      this._NS.error('Please fill all required fields properly');
      return;
    }

    let formValue = this.requestForm.value;

    let reqObject = {
      budgetRange: this._US.parsePriceRange(formValue.budgetRange),
      microMarkets: formValue.microMarkets,
      configuration: formValue.configuration,
      communityPreference: formValue.communityPreference,
      projectStatus: formValue.projectStatus,
      isRequestSource: 'Admin',
      notes: formValue.notes,
      reqUser: {
        email: this.userDetails.email,
        name: this.userDetails.name,
        id: this.userDetails._id,
        phone: this.userDetails.phone,
        type: this.userDetails?.userType ?? 'Basic'
      },
    };

    this._US.createUserPreference(reqObject).subscribe({
      next: (res) => {
        this._NS.success(res.message);
        this.requestForm.reset();
        this.getUserCustomerPre(this.userDetails._id);
        this.closeRequestModal();
      },
      error: (err) => {
        this._NS.error(err.message);
        this.closeRequestModal();
      },
    });
  }
  userCustPre:any
  getUserCustomerPre(id:any){
    this._US.getUserPropertyPreferenceReq(id).subscribe({
      next: (res) => {
        this.requests = res.data
      },
      error: (err) => {
        this._NS.error(err);
        this.closeRequestModal();
      },
    });

  }

  deleteRequest(index: number) {
    this.requests.splice(index, 1);
  }
  toggleMicroMarket(market: string) {
    const selected = this.requestForm.value.microMarkets || [];

    if (selected.includes(market)) {
      this.requestForm.patchValue({
        microMarkets: selected.filter((m: string) => m !== market),
      });
    } else {
      // if (selected.length >= 3) {
      //   this._NS.error('You can select maximum 3 micro markets');
      //   return;
      // }

      this.requestForm.patchValue({
        microMarkets: [...selected, market],
      });
    }
  }
  toggleProjectStatus(status: string) {
    const selected = this.requestForm.value.projectStatus || [];

    if (selected.includes(status)) {
      this.requestForm.patchValue({
        projectStatus: selected.filter((s: string) => s !== status),
      });
    } else {
      this.requestForm.patchValue({
        projectStatus: [...selected, status],
      });
    }
  }
  toggleMicroMarketDropdown() {
    this.microMarketDropdownOpen = !this.microMarketDropdownOpen;
  }
  @HostListener('document:click', ['$event'])
  closeDropdowns(event: Event) {
    const target = event.target as HTMLElement;

    if (!target.closest('.micro-market-dropdown')) {
      this.microMarketDropdownOpen = false;
    }

    if (!target.closest('.project-status-dropdown')) {
      this.projectStatusDropdownOpen = false;
    }
  }

  toggleProjectStatusDropdown() {
    this.projectStatusDropdownOpen = !this.projectStatusDropdownOpen;
  }

  toggleSelection(controlName: string, value: string) {
    const selected = this.requestForm.get(controlName)?.value || [];

    if (selected.includes(value)) {
      this.requestForm.patchValue({
        [controlName]: selected.filter((v: string) => v !== value),
      });
    } else {
      if (controlName === 'microMarkets' && selected.length >= 3) {
        this._NS.error('You can select maximum 3 micro-markets');
        return;
      }
      this.requestForm.get(controlName)?.markAsTouched();
      this.requestForm.get(controlName)?.updateValueAndValidity();

      this.requestForm.patchValue({
        [controlName]: [...selected, value],
      });
    }
  }

  isSelected(controlName: string, value: string): boolean {
    const selected = this.requestForm.get(controlName)?.value || [];
    return selected.includes(value);
  }
  onMicroMarketSearch(event: any) {
    const value = event.target.value.toLowerCase().trim();
    this.filteredCluster = this.savedCluster.filter((market: any) =>
      market.micromarketName?.toLowerCase().includes(value)
    );
  }
  removeSelection(controlName: string, value: string) {
    const selected = this.requestForm.get(controlName)?.value || [];

    this.requestForm.patchValue({
      [controlName]: selected.filter((v: string) => v !== value),
    });
  }
  isRoteHasPermissions(perm:any){
    return this._AS.hasPermission(perm)
  }
  getAllAdvisor() {
    this.loaderService.show();
    this._AsS.advisor().subscribe({
      next: (res: any) => {
        this.allAdvisors = res.data.filter((_:any)=>_.role.id == 'sales_advisor'); // Save the full data
        this.advisorList.set(this.allAdvisors)
        // this._NS.success('Advisors fetched successfully');
      },
      error: (err:any) => {
        this.loaderService.hide()
        this._NS.error(err);
      },
      complete: () => {
        this.loaderService.hide()
      },
    });
  }
  onSearch(event: any) {
    const query = event.target.value.toLowerCase();
    const filtered = this.allAdvisors.filter(
      (a: any) =>
        a.name.toLowerCase().includes(query) ||
        a.specialization.toLowerCase().includes(query)
    );
    this.advisorList.set(filtered);
  }

  selectAdvisor(id: string | null) {
    this.selectedAdvisorId.set(id);
  }
  confirmAdvisor() {
    const currentId = this.selectedAdvisorId();
    const selectedAdvisor = this.advisorList().find((a:any) => a._id === currentId);
    if (selectedAdvisor) {
      const payload = {
        advisorId: currentId,
        name: selectedAdvisor.name,
        email: selectedAdvisor.email,
        phone: selectedAdvisor.phone,
        specialization: selectedAdvisor.specialization,
        image:selectedAdvisor.advisorImg
      };
      this.loaderService.show();
      this._US.assignedAdvisor({userId:this.userDetails._id ,assignedAdvisor:payload}).subscribe({
        next: (res:any) => {
          this.loaderService.hide();
          if (res.success) {
            this.getUserDetails(this.userDetails._id)
            this._NS.success(
              res.message || `Advisor ${payload.name} assigned successfully!`
            );
            this.closeModal();
          } else {
            this._NS.error(res.message);
          }
        },
        error: (err:any) => {
          this.loaderService.hide();
          const specificError = Array.isArray(err.details)
            ? err.details[0]
            : err.message;
          this._NS.error(specificError);
          this.closeModal();
        },
      });
    }
  }
  goBack() {
    this.location.back();
  }
  hasAdvisorAssigned(): boolean {
    return !!this.userDetails?.assignedAdvisor?.advisorId;
  }
  getDaysRemaining(endDate: string): number {
    const end = new Date(endDate).getTime();
    const now = new Date().getTime();
    return Math.max(0, Math.ceil((end - now) / (1000 * 60 * 60 * 24)));
  }
  
  getSubscriptionProgress(startDate: string, endDate: string): number {
    const start = new Date(startDate).getTime();
    const end   = new Date(endDate).getTime();
    const now   = new Date().getTime();
    const total = end - start;
    const elapsed = now - start;
    return Math.min(100, Math.max(0, Math.round((elapsed / total) * 100)));
  }


  // Add methods inside component class

  openApprovalModal(userId: string, state: string) {
    this.approvalUserId = userId;
    this.approvalState = state;
    this.approvalReason = '';
    this.showApprovalModal = true;
  }

  closeApprovalModal() {
    this.showApprovalModal = false;
    this.approvalReason = '';
  }

  submitApprovalUI() {
    if (!this.approvalReason.trim()) {
      this._NS.error('Please enter reason');
      return;
    }
    this.isApprovedUser(this.approvalUserId, this.approvalState,this.approvalReason);
    this.closeApprovalModal();
  }


  sharedLinks: any[] = [];
  copySharedLink(link: string) {
      navigator.clipboard.writeText(link);
      this._NS.success('Link copied successfully');
    }


    loadSharedLinks() {
      this.sharedLinks = this.userDetails?.sharedLinks || [];
  }
  sharedPropertyData:any
  getUserSharedProperty(userId:string | any){
    this._US.getUserSharedPropertyLink(userId).subscribe((res: any) => {
      this.sharedPropertyData = res.data;
    });

  }

  // In your component
get groupedSharedProperties() {
  const shares = this.sharedPropertyData?.sharedProperties ?? [];
  const map = new Map<string, any>();

  shares.forEach((share:any) => {
    if (!map.has(share.shareToken)) {
      map.set(share.shareToken, {
        shareToken: share.shareToken,
        link:share.link,
        expiresAt: share.expiresAt,
        createdAt: share.createdAt,
        properties: []
      });
    }
    if (!map.has(share.shareToken)) {
      map.set(share.shareToken, { properties: [] });
    }
    
    const entry = map.get(share.shareToken);
    
    if (!entry.properties) {
      entry.properties = [];
    }
    
    if (share.propertyDetails) {
      entry.properties.push(share.propertyDetails);
    }
  });

  return Array.from(map.values());
}

isExpired(expiresAt: string): boolean {
  return new Date(expiresAt) < new Date();
}

getMinPrice(price: any[]): string {
  if (!price?.length) return 'N/A';
  const min = Math.min(...price.map(p => p.price));
  const cr = min / 10000000;
  return cr >= 1 ? `₹${cr.toFixed(2)} Cr` : `₹${(min / 100000).toFixed(2)} L`;
}

copyLinks(token: string) {
  const url = `${token}`;
  navigator.clipboard.writeText(url);
}
  
}
